import { Container } from "reactstrap";
// import starIcon from "../../assets/images/icons/star.svg";
import mapIcon from "../../assets/images/icons/maps-and-flags.png";
import * as userAction from "../../actions/user-action-type";
import HeaderBanner from "../../components/banners/HeaderBanner";
import cx from "classnames";
import { useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-multi-lang";
import ReactPixel from "react-facebook-pixel";
import ContentLoader from "react-content-loader";
import "./style.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "react-loader-spinner";

const tempImage =
  "https://images.unsplash.com/photo-1624561500881-d97c12c521e1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1051&q=80";

function RenderBookCard(props) {
  const {
    package_name,
    arabic_name,
    url_slug,
    price,
    original_price,
    child_price,
    rating,
    img,
    destination_id,
    destinationData,
    offer_tag,
    offer_tag_text,
    redirect,
    redirect_url,
    description,
    short_description,
  } = props;
  const history = useHistory();
  const t = useTranslation();
  const [destName, setDestName] = useState("");

  useEffect(() => {
    for (var i = 0; i < destinationData?.length; i++) {
      if (destinationData[i]["id"] == destination_id) {
        setDestName(destinationData[i].name);
      }
    }
  }, [destinationData, destination_id]);

  // Get destination name directly for GTM
  const getDestinationName = () => {
    if (!destinationData) return "";
    const destination = destinationData.find((d) => d.id == destination_id);
    return destination ? destination.name : "";
  };

  const top = () => (
    <div className="top-content">
      <div>
        {destName ? (
          <p className="rating">
            <img src={mapIcon} alt="rating" />
            {destName}
            {/* {rating} */}
          </p>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );

  // Hardcoded descriptions for specific packages
  const getHardcodedDescription = (name) => {
    const lowerName = (name || "").toLowerCase();
    if (lowerName.includes("overnight experiences") && (lowerName.includes("camping") || lowerName.includes("glamping"))) {
      return "Escape to the desert for a night under the stars, with options from classic camping to luxurious glamping, the choice is yours.";
    }
    if (lowerName.includes("mleiha glamping")) {
      return "Unwind in the desert with two glamping options – Premium Glamping Tents with ensuite bathrooms and added privacy, or Standard Glamping Tents offering the same cosy comfort with shared facilities and open-air views.";
    }
    if (lowerName.includes("overnight camping")) {
      return "Experience the desert the authentic way with traditional camping under a starlit sky for those seeking an authentic desert camp adventure!";
    }
    return null;
  };

  const bottom = () => {
    const hardcodedDesc = getHardcodedDescription(package_name);
    
    return (
    <div className="bottom-div">
      <div className="card-content-wrapper">
        {localStorage.getItem("user_language") == "en" ? (
          <h3 className="card-title">{package_name}</h3>
        ) : (
          <h3 className="card-title">{arabic_name}</h3>
        )}
        <div
          className="description-text"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          dangerouslySetInnerHTML={{
            __html: (
              description ||
              short_description ||
              hardcodedDesc ||
              "Discover amazing experiences and create unforgettable memories at this destination. Book your adventure today!"
            )
              .replace(/<p>\s*(&nbsp;|\s)*<\/p>/gi, '') // Remove empty p tags
              .replace(/&nbsp;/gi, ' ') // Replace nbsp with space
              .replace(/<br\s*\/?>/gi, ' ') // Replace br tags with space
              .replace(/\r?\n|\r/g, ' ') // Replace newlines with space
              .replace(/\s+/g, ' ') // Collapse multiple spaces
              .trim(),
          }}
        />
        <button
          className="know-more-button"
          onClick={(e) => {
            e.stopPropagation();
            // Use the same click logic as the card
            if (window.dataLayer) {
              const packageTitle =
                localStorage.getItem("user_language") == "en"
                  ? package_name
                  : arabic_name;
              const packagePrice = price || child_price || "0";
              const destinationName = getDestinationName();

              window.dataLayer.push({
                event: "package_click",
                package_data: {
                  title: packageTitle || "",
                  price: packagePrice,
                  original_price: original_price || "0",
                  destination: destinationName,
                  url_slug: window.location.origin + "/p/" + (url_slug || ""),
                },
              });
            }
            if (redirect === "1") {
              // Convert full URL to relative path if same domain
              const url = redirect_url || "";
              if (url.includes("discovershurooq.ae")) {
                const relativePath = url.replace(/https?:\/\/[^\/]+/, "");
                // Force full page reload for /t/ routes to ensure state is properly reset
                if (relativePath.startsWith("/t/")) {
                  window.location.href = relativePath;
                } else {
                  history.push(relativePath);
                }
              } else {
                window.location.href = url;
              }
            } else {
              history.push(`/p/${url_slug}`);
            }
          }}
        >
          {redirect === "1" ? "KNOW MORE" : "BOOK NOW"}
        </button>
      </div>
    </div>
  );
  };
  const image =
    "https://api.discovershurooq.ae/cdn-cgi/image/width=900,height=500,quality=85,format=auto/files/" +
    img;
  return (
    <div className="activity-item">
      {offer_tag == 1 ? (
        <div className="ribbon ribbon-top-left">
          <span>{offer_tag_text}</span>
        </div>
      ) : null}
      <div
        className="activity-content"
        data-gtm-title={
          localStorage.getItem("user_language") == "en"
            ? package_name
            : arabic_name
        }
        data-gtm-price={price != "" ? price : child_price}
        data-gtm-original-price={original_price || ""}
        data-gtm-destination={destName}
        data-gtm-url-slug={url_slug}
        onClick={(e) => {
          // Push to dataLayer for GTM tracking
          if (window.dataLayer) {
            const packageTitle =
              localStorage.getItem("user_language") == "en"
                ? package_name
                : arabic_name;
            const packagePrice = price || child_price || "0";
            const destinationName = getDestinationName();

            window.dataLayer.push({
              event: "package_click",
              package_data: {
                title: packageTitle || "",
                price: packagePrice,
                original_price: original_price || "0",
                destination: destinationName,
                url_slug: window.location.origin + "/p/" + (url_slug || ""),
              },
            });

            console.log("GTM Push:", {
              event: "package_click",
              package_data: {
                title: packageTitle || "",
                price: packagePrice,
                original_price: original_price || "0",
                destination: destinationName,
                url_slug: window.location.origin + "/p/" + (url_slug || ""),
              },
            });
          }
          if (redirect === "1") {
            // Convert full URL to relative path if same domain
            const url = redirect_url || "";
            if (url.includes("discovershurooq.ae")) {
              const relativePath = url.replace(/https?:\/\/[^\/]+/, "");
              // Force full page reload for /t/ routes to ensure state is properly reset
              if (relativePath.startsWith("/t/")) {
                window.location.href = relativePath;
              } else {
                history.push(relativePath);
              }
            } else {
              window.location.href = url;
            }
          } else {
            history.push(`/p/${url_slug}`);
          }
        }}
      >
        <div className="activity-image-wrapper">
          <LazyLoadImage
            className="activity-image"
            src={image}
            alt={package_name}
            effect="blur"
            placeholderSrc={`https://api.discovershurooq.ae/cdn-cgi/image/width=100,quality=50,format=auto/files/${img}`}
          />
        </div>
        <div className="activity-details">{bottom()}</div>
      </div>
    </div>
  );
}

function BookYourExperience(props) {
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [currentSlug, setCurrentSlug] = useState(null);
  const btns = [
    { active: "true", name: "All" },
    { active: "false", name: "Couples" },
    { active: "false", name: "Friends" },
    { active: "false", name: "Family" },
    { active: "false", name: "Kids" },
  ];
  const t = useTranslation();
  const history = useHistory();
  localStorage.setItem("pathname", history.location.pathname);
  const { url_slug } = props.match.params;

  const [tag, setTag] = useState("All");
  const [backImg, setBackImg] = useState(
    "../../../assets/images/backgrounds/head-banner.png"
  );
  const [destName, setDestName] = useState("");
  const [destDcp, setDestDcp] = useState("");
  const [destHoverDcp, setDestHoverDcp] = useState("");
  const {
    getdestPackages,
    getDestPackageStatus,
    homeData,
    getHomeData,
    destPackagesData,
    destinationVoucherData,
    getDestVouchers,
    destinationData,
    getDestinationData,
    resetDestPackages,
  } = props;

  console.log(destPackagesData);
  
  // Reset state and fetch fresh data when url_slug changes
  useEffect(() => {
    // Scroll to top immediately
    window.scrollTo(0, 0);
    
    // Reset Redux store data immediately to prevent showing old data
    resetDestPackages();
    
    // Reset loading states for new destination
    setLoading(true);
    setLoader(true);
    setDataLoaded(false);
    setCurrentSlug(null); // Set to null first, will be set to url_slug after API responds
    setDestName("");
    setDestDcp("");
    setDestHoverDcp("");
    setBackImg("../../../assets/images/backgrounds/head-banner.png");

    const data = new FormData();
    data.append("action", "packages");
    data.append("slug", url_slug);
    const voucherDta = new FormData();
    voucherDta.append("action", "listVoucherByDesitnation");
    voucherDta.append("slug", url_slug);

    const home_data = new FormData();
    home_data.append("action", "HomeData");

    const formData = new FormData();
    formData.append("action", "destinations");
    getDestinationData(formData);
    getHomeData(home_data);
    getdestPackages(data);
    getDestVouchers(voucherDta);
  }, [url_slug]);

  for (var i = 0; i < destinationData?.length; i++) {
    if (destinationData[i]["url_slug"] == url_slug) {
      if (destinationData[i]["name"]) {
        document.title = destinationData[i]["name"];
        let randomNum_1 = 0;
        let randomNum_2 = 0;
        let randomNum_3 = 0;
        let contentID = "";
        if (destPackagesData?.length > 0) {
          for (var j = 0; j < destPackagesData?.length; j++) {
            if (j > 0) {
              contentID += ",";
            }
            contentID += `'p-${destPackagesData[j].url_slug}'`;
          }
        }
        ReactPixel.track("ViewContent", {
          content_name: `${destinationData[i]["name"]} - Destination`,
          content_category: "page",
          content_type: "product_group",
          content_ids: `[${contentID}]`,
        });
      }
    }
  }

  // Only show content when fresh data for current slug has loaded
  useEffect(() => {
    // Skip if we haven't received destination data yet
    if (!destinationData || destinationData.length === 0) {
      return;
    }
    
    // Only proceed if API has returned success
    if (getDestPackageStatus !== "success") {
      return;
    }
    
    // Find the current destination
    const currentDestination = destinationData.find(d => d.url_slug === url_slug);
    if (!currentDestination) {
      return;
    }
    
    // Check if destPackagesData belongs to current url_slug by verifying destination match
    if (destPackagesData && destPackagesData.length > 0) {
      if (destPackagesData[0]?.destination_id === currentDestination.id) {
        setCurrentSlug(url_slug);
        setDataLoaded(true);
        setLoading(false);
        setLoader(false);
        
        setBackImg(
          `https://api.discovershurooq.ae/files/` +
            currentDestination["featured_image"]
        );
        setDestName(currentDestination["name"]);
        setDestDcp(currentDestination["description"]);
        setDestHoverDcp(currentDestination["hover_text"]);
      }
    } else if (destPackagesData && destPackagesData.length === 0) {
      // No packages for this destination, but API has responded with success
      setCurrentSlug(url_slug);
      setDataLoaded(true);
      setLoading(false);
      setLoader(false);
      
      setBackImg(
        `https://api.discovershurooq.ae/files/` +
          currentDestination["featured_image"]
      );
      setDestName(currentDestination["name"]);
      setDestDcp(currentDestination["description"]);
      setDestHoverDcp(currentDestination["hover_text"]);
    }
  }, [destPackagesData, destinationData, url_slug, getDestPackageStatus]);

  const renderLoader = () => (
    <div className="activities-list">
      {["", "", ""].map((data, index) => (
        <div key={"bookData" + index} className="activity-loader">
          <ContentLoader
            speed={2}
            viewBox="0 0 1200 300"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
          >
            <rect x="0" y="0" rx="8" ry="8" width="400" height="300" />
            <rect x="430" y="20" rx="4" ry="4" width="600" height="25" />
            <rect x="430" y="60" rx="3" ry="3" width="700" height="15" />
            <rect x="430" y="85" rx="3" ry="3" width="680" height="15" />
            <rect x="430" y="110" rx="3" ry="3" width="720" height="15" />
            <rect x="430" y="135" rx="3" ry="3" width="650" height="15" />
            <rect x="430" y="240" rx="6" ry="6" width="150" height="40" />
          </ContentLoader>
        </div>
      ))}
    </div>
  );

  const renderData = (tag) => {
    // Only show "No Packages" messages when data is fully loaded AND matches current slug
    const isDataReady = dataLoaded && currentSlug === url_slug && getDestPackageStatus === "success";
    
    const visiblePackages = destPackagesData.filter(
      (data) =>
        data.hide == "0" &&
        data.enable == "1" &&
        data.checkout?.includes("DiscoverShurooq")
    );
    
    return (
      <div className="activities-list">
        {isDataReady && visiblePackages.length === 0 ? (
          <div style={{ justifyContent: "center", display: "flex" }}>
            <h2 style={{ textAlign: "center", marginTop: "4rem" }}>
              Coming Soon ...
            </h2>
          </div>
        ) : null}
        {destPackagesData
          .sort((a, b) => {
            if (a.position === null && b.position === null) {
              return 0;
            }
            if (a.position === null) {
              return 1;
            }
            if (b.position === null) {
              return -1;
            }
            return Number(a.position) - Number(b.position);
          })
          .map((data, index) =>
            data.hide == "0" &&
            data.enable == "1" &&
            data.checkout?.includes("DiscoverShurooq") ? (
              tag != "All" && !data.tags.includes(tag) ? null : (
                <RenderBookCard key={"bookData" + index} {...data} destinationData={destinationData} />
              )
            ) : null
          )}
      </div>
    );
  };

  const showTagData = (tagName) => {
    setTag(tagName);
  };
  return (
    <>
      {!dataLoaded || currentSlug !== url_slug || getDestPackageStatus !== "success" ? (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader color="#FE5734" type="Oval" />
        </div>
      ) : (
        <div>
          <HeaderBanner
            linkPage={[
              { type: "link", name: "Home", link: "/" },
              { name: "Book Your Experience" },
            ]}
            backgroundImage={backImg}
            destinationName={destName}
            destinationDescription={destDcp}
            destinationHoverDescription={destHoverDcp}
          />
          <section className="book-youre-experience-section">
            <Container>
              <h2 className="sec-title">Book Your Experience</h2>
              <div className="tab-box-btn">
                <div className="wrapper">
                  {btns.map(({ active, name }, index) => (
                    <button
                      kye={index}
                      className={cx({ active: active })}
                      onClick={(e) => showTagData(name)}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              </div>
              {loader ? renderLoader() : renderData(tag)}
            </Container>
          </section>
        </div>
      )}
    </>
  );
}
const mapStateToProps = ({
  user: {
    homeData,
    getDestPackageStatus,
    destPackagesData,
    destinationVoucherData,
    destinationData,
  },
}) => ({
  homeData,
  getDestPackageStatus,
  destPackagesData,
  destinationVoucherData,
  destinationData,
});

const mapDispatchToProps = {
  getdestPackages: userAction.getdestPackages,
  getHomeData: userAction.getHomeData,
  getDestVouchers: userAction.getDestVouchers,
  getDestinationData: userAction.getDestinationData,
  resetDestPackages: userAction.resetDestPackages,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookYourExperience));
